import { FiscalYearMonth } from "../enums";
export const FISCAL_YEAR_MONTHS = [
    FiscalYearMonth.JANUARY,
    FiscalYearMonth.FEBRUARY,
    FiscalYearMonth.MARCH,
    FiscalYearMonth.APRIL,
    FiscalYearMonth.MAY,
    FiscalYearMonth.JUNE,
    FiscalYearMonth.JULY,
    FiscalYearMonth.AUGUST,
    FiscalYearMonth.SEPTEMBER,
    FiscalYearMonth.OCTOBER,
    FiscalYearMonth.NOVEMBER,
    FiscalYearMonth.DECEMBER,
];
export const DEFAULT_FISCAL_YEAR_MONTH = FiscalYearMonth.JANUARY;
export const getFiscalYearStartMonthNumber = (fiscalYearMonthStart) => FISCAL_YEAR_MONTHS.indexOf(fiscalYearMonthStart ?? DEFAULT_FISCAL_YEAR_MONTH) + 1;
export const getFiscalYearWindowStart = (fiscalYearStartMonth, yearsBack, now = new Date()) => {
    const hasFiscalYearStartedThisCalendarYear = now.getUTCMonth() + 1 >= fiscalYearStartMonth;
    const startYear = now.getUTCFullYear() - (hasFiscalYearStartedThisCalendarYear ? 0 : 1) - yearsBack;
    return new Date(Date.UTC(startYear, fiscalYearStartMonth - 1, 1));
};
